export const SALESPROMO_LOADING = "SALESPROMO_LOADING";
export const SALESPROMO_RESET = "SALESPROMO_RESET";
export const GET_SALESPROMO = "GET_SALESPROMO";
export const GET_SALESPROMO_SUCCESS = "GET_SALESPROMO_SUCCESS";
export const GET_SALESPROMO_FAIL = "GET_SALESPROMO_FAIL";
export const DELETE_SALESPROMO = "DELETE_SALESPROMO"
export const DELETE_SALESPROMO_SUCCESS = "DELETE_SALESPROMO_SUCCESS"
export const DELETE_SALESPROMO_FAIL = "DELETE_SALESPROMO_FAIL"
export const UPDATE_SALESPROMO = "UPDATE_SALESPROMO"
export const UPDATE_SALESPROMO_SUCCESS = "UPDATE_SALESPROMO_SUCCESS"
export const UPDATE_SALESPROMO_FAIL = "UPDATE_SALESPROMO_FAIL"
export const ADD_NEW_SALESPROMO = "ADD_NEW_SALESPROMO"
export const ADD_SALESPROMO_SUCCESS = "ADD_SALESPROMO_SUCCESS"
export const ADD_SALESPROMO_FAIL = "ADD_SALESPROMO_FAIL"